"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));

var _date = _interopRequireDefault(require("@spothero/utils/date"));

var _DatePickerCalendarNavigation = _interopRequireDefault(require("./DatePickerCalendarNavigation"));

var DATE = new Date();

var DatePickerCalendar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DatePickerCalendar, _Component);

  function DatePickerCalendar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DatePickerCalendar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DatePickerCalendar).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedDate: _this.props.selectedDate
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onDaySelected", function (day, _ref, evt) {
      var selected = _ref.selected,
          disabled = _ref.disabled;

      if (disabled) {
        return;
      }

      var onChange = _this.props.onChange;
      var selectedDate = (0, _moment.default)(day).format('MM/DD/YYYY');

      _this.setState({
        selectedDate: selectedDate
      });

      if (onChange) {
        onChange(selectedDate);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_modifierSelected", function (day) {
      var selectedDate = _this.state.selectedDate;

      if (!(0, _isEmpty.default)(selectedDate)) {
        return _reactDayPicker.DateUtils.isSameDay(_date.default.getAsDate(selectedDate), day);
      } else {
        return null;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_modifierDisabled", function (day) {
      var _this$props = _this.props,
          disablePast = _this$props.disablePast,
          disableBefore = _this$props.disableBefore,
          disableAfter = _this$props.disableAfter;
      var isDayDisabled = false;
      var disableDay = false;

      if (disableBefore) {
        disableDay = _date.default.isBefore(day, _date.default.getAsDate(disableBefore));
        isDayDisabled = disableDay;
      }

      if (disableAfter && !isDayDisabled) {
        disableDay = _date.default.isAfter(day, _date.default.getAsDate(disableAfter));
        isDayDisabled = disableDay;
      }

      if (disablePast && !isDayDisabled) {
        disableDay = _reactDayPicker.DateUtils.isPastDay(day);
      }

      return disableDay;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderDayMarkup", function (day) {
      var _context, _context2;

      var m = (0, _moment.default)(day);
      var date = (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(m.format('MM'), "/")).call(_context2, m.format('DD'), "/")).call(_context, m.format('YYYY'));
      return _react.default.createElement("span", {
        "data-date": date
      }, day.getDate());
    });
    _this._weekdayTitles = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    return _this;
  }

  (0, _createClass2.default)(DatePickerCalendar, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          initialMonth = _this$props2.initialMonth,
          disablePast = _this$props2.disablePast,
          disableBefore = _this$props2.disableBefore,
          disableAfter = _this$props2.disableAfter,
          overrideInitialMonthWithSelected = _this$props2.overrideInitialMonthWithSelected;
      var selectedDate = this.state.selectedDate;
      var classes = (0, _classnames.default)('DatePicker-calendar', className);
      var firstMonth = initialMonth;
      var fromMonth = disablePast ? DATE : null;
      var toMonth = null;

      if (disableBefore) {
        var beforeDate = _date.default.getAsDate(disableBefore);

        if (fromMonth) {
          if (_date.default.isAfter(beforeDate, fromMonth)) {
            fromMonth = beforeDate;
          }
        } else {
          fromMonth = beforeDate;
        }

        firstMonth = fromMonth;
      }

      if (disableAfter) {
        toMonth = _date.default.getAsDate(disableAfter);
      }

      if (selectedDate && overrideInitialMonthWithSelected) {
        firstMonth = _date.default.getAsDate(selectedDate);
      }

      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_reactDayPicker.default, {
        selectedDays: this._modifierSelected,
        disabledDays: this._modifierDisabled,
        onDayClick: this._onDaySelected,
        fromMonth: fromMonth,
        toMonth: toMonth,
        initialMonth: firstMonth,
        renderDay: this._renderDayMarkup,
        weekdaysShort: this._weekdayTitles,
        navbarElement: _react.default.createElement(_DatePickerCalendarNavigation.default, null),
        showOutsideDays: true
      }));
    }
  }]);
  return DatePickerCalendar;
}(_react.Component);

exports.default = DatePickerCalendar;
(0, _defineProperty2.default)(DatePickerCalendar, "defaultProps", {
  selectedDate: '',
  initialMonth: DATE,
  disablePast: true,
  overrideInitialMonthWithSelected: true
});